import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { BASE_URL, ENDPOINTS } from "@/constants"

interface ReverseCycleProps {
  subscriptionId: string
  cycleId: string
  reason: string
  /**
   * Reverte mesmo que o banco recuse a baixa, falhe ou não responda. Rota separada porque exige
   * superadministrador — no gateway o escopo é por rota, não por parâmetro.
   */
  forced?: boolean
}

/**
 * Reversão do ciclo de uma assinatura.
 *
 * O que se desfaz é a cobrança daquele ciclo. O pedido avulso tem ação própria, na página dele.
 */
export const useReverseCycleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      subscriptionId,
      cycleId,
      reason,
      forced = false,
    }: ReverseCycleProps) => {
      const suffix = forced ? "forced-reversal" : "reversal"

      await api.put(
        `${BASE_URL}${ENDPOINTS.SUBSCRIPTIONS}/${subscriptionId}/cycles/${cycleId}/${suffix}`,
        { reason }
      )
    },
    onSuccess: async () => {
      // Invalidação por PREFIXO: a ficha da assinatura, a lista de ciclos e a listagem de pedidos
      // são queries distintas sobre o mesmo fato. Invalidar só uma deixa as outras exibindo o
      // status antigo, e a ação continua oferecida sobre um ciclo já revertido.
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.SUBSCRIPTIONS],
      })
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.SUBSCRIPTION],
      })
      await queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.ORDERS],
      })
    },
  })
}
